import React, { useRef, useState } from 'react';
import './styles.css';

import PropTypes from 'prop-types';
import { Form } from '@unform/web';
import { Input, Checkbox } from '../../../components/Form';
import Button from '../../../components/Button';
import { MdClear, MdSearch } from 'react-icons/md';
import Row from '../../../components/Row';
import Grid from '../../../components/Grid';

function FormulaSearch({ onSubmit: handleSubmit, onClear: handleClear }) {
  const formRef = useRef(null);

  const [ref, setRef] = useState('');
  const [startsWith, setStartsWith] = useState(false);

  function resetForm() {
    setRef('');
    setStartsWith(false);
  }

  return (
    <div className='search-container'>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <Row>
          <Grid cols='12'>
            <Checkbox
              id='startsWith'
              name='startsWith'
              label='Iniciar com...'
              value={startsWith}
              checked={startsWith}
              onChange={(e) => setStartsWith(e.target.checked)}
            />
          </Grid>
        </Row>

        <Row>
          <Grid cols='12 10'>
            <Input
              id='ref'
              name='ref'
              value={ref}
              onChange={(e) => setRef(e.target.value)}
              placeholder='Pesquise por nome, recomendação de uso, posologia ou observação'
            />
          </Grid>

          <Grid cols='12 2'>
            <Button color='info' type='submit'>
              <MdSearch size={18} />
            </Button>

            <Button
              type='button'
              className='ml-2'
              color='info'
              handleclick={() => {
                handleClear();
                resetForm();
              }}
            >
              <MdClear size={18} />
            </Button>
          </Grid>
        </Row>
      </Form>

      <hr className='divider' />
    </div>
  );
}

FormulaSearch.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClear: PropTypes.func,
};

export default FormulaSearch;
